<template>
    <div class="py-12">
        <DataTable
            :title="t('vue.teams_accounts')"
            searchable
            :headers="headers"
            :items="teams"
        >
            <template #item-profile_photo_url="{ data }">
                <div class="flex justify-center">
                    <img
                        v-if="data"
                        class="h-10 w-10 rounded-full"
                        :src="data as string"
                        alt="Team profile photo record"
                    />
                    <img
                        v-else
                        class="h-10 w-10 rounded-full"
                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/600px-No_image_available.svg.png"
                        alt="Team profile photo stock image fallback"
                    />
                </div>
            </template>

            <template #item-custom="{ row }">
                <div class="flex w-full justify-center">
                    <AtomicButton
                        color="white"
                        size="sm"
                        @click="handleShowTeam(row)"
                    >
                        <template #icon>
                            <MagnifyingGlassIcon class="h-6 w-6" />
                        </template>
                    </AtomicButton>
                </div>
            </template>
        </DataTable>
    </div>
</template>

<script lang="ts" setup>
import type IPaginationData from "@/types/Atomic/IPaginationData";
import { MagnifyingGlassIcon } from "@heroicons/vue/24/outline";
import route from "ziggy-js";
import type IDataTableHeader from "@/components/Atomic/DataTable/types/IDataTableHeader";
import { router } from "@inertiajs/vue3";
import type ICurrentTeam from "@/types/Members/ICurrentTeam";
import { useTranslations } from "@/composables/useTranslations";

defineProps<{
    teams: IPaginationData<ICurrentTeam>;
}>();

// Get access to translations
const { t } = useTranslations();

const headers: IDataTableHeader[] = [
    { text: "", id: "profile_photo_url" },
    {
        text: t("vue.id"),
        id: "id",
        sortable: true,
        sortableId: "id",
    },
    {
        text: t("vue.name"),
        id: "name",
        sortable: true,
        sortableId: "name",
    },
    {
        text: t("vue.owner_email"),
        id: "email",
        sortable: true,
        sortableId: "email",
    },
    {
        text: t("vue.domains_count"),
        id: "domains_quantity",
        sortable: true,
        sortableId: "domains_quantity",
    },
    {
        text: t("vue.subscription_type"),
        id: "subscription_type",
    },
    {
        text: t("vue.subscription_period"),
        id: "subscription_period",
    },
    {
        text: t("vue.subscription_amount"),
        sortable: true,
        id: "paddle_sub_amount",
        sortableId: "paddle_sub_amount",
    },
    {
        text: t("vue.paddle_sub_last_transaction_amount"),
        sortable: true,
        id: "paddle_sub_last_transaction_amount",
        sortableId: "paddle_sub_last_transaction_amount",
    },
    { text: "", id: "custom" },
];

const handleShowTeam = function (team: ICurrentTeam) {
    router.get(
        route("kiosk.teams.members.index", {
            team: team.id,
        }),
    );
};
</script>

<style></style>
